"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _lodash = /*#__PURE__*/ _interop_require_default(require("lodash"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getReleaseTimes = function(offer) {
    return {
        endTime: _lodash.default.get(offer, 'release.endTime', null),
        startTime: _lodash.default.get(offer, 'release.startTime', null)
    };
};
var _default = getReleaseTimes;
